import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Admin} from '../../../components/sections';
import Section from '../../../components/Section';

class StaffVerificationSection extends Component {
    constructor(props){
        super(props);
        this.state = {showModal: false, item: null};        
        
        this.onCloseModal = this.onCloseModal.bind(this);       

        const {actions} = props;
        actions.fetchPendingStaffVerifications();
        this.onOpen = this.onOpen.bind(this);

        this.onVerificationProcessed = this.onVerificationProcessed.bind(this);
        
    }
    
    
    onCloseModal(e){
        this.setState({showModal: false, item: null});
    }

    onOpen(e, {data}){
        this.setState({showModal: true, item: data});
    }

    async onVerificationProcessed(e,item)
    {
        //do action
        const {actions} = this.props;
        await actions.updateStaffVerificationRequest(item);
        await actions.fetchPendingStaffVerifications();
        this.onCloseModal(e);
    }

    
    render() {
        const {showModal, item} = this.state;       
        const {admin} = this.props; 
        const items = admin.pendingVerifications;
        const error = admin.error;

        return (
            <Section name="verify" title="Staff Verification" color="red" mobileShow={this.props.mobileShow}>                
                    <Admin.NewAccountRequests items={items} onOpen={this.onOpen} ></Admin.NewAccountRequests>
                    <Admin.ProcessNewAccountRequestModal item={item} open={showModal} onClose={this.onCloseModal} onVerificationProcessed={this.onVerificationProcessed} error={error} />
            </Section>
        );
    }
}

StaffVerificationSection.propTypes = {
    actions: PropTypes.object.isRequired,
    admin: PropTypes.object.isRequired,
};

export default StaffVerificationSection;